import digitsOnly from '../../../form/field-validation/digitsOnly';

const postcodeFormatError = 'checkout.error.formFields.postalCode';
const digitsOnlyValidator = digitsOnly();

const numberOfDigitsPostcodeValidator = length => (value) => {
  if (!value) return;
  const digitsOnlyError = digitsOnlyValidator(value);
  if (digitsOnlyError) return digitsOnlyError;
  if (value.length !== length) {
    return [postcodeFormatError, '0'.repeat(length)];
  }
};

export const fourDigitsPostcodeValidator = numberOfDigitsPostcodeValidator(4);
export const fiveDigitsPostcodeValidator = numberOfDigitsPostcodeValidator(5);
export const sixDigitsPostcodeValidator = numberOfDigitsPostcodeValidator(6);
